import React from 'react'
import { Link } from 'react-router-dom'

const CorpartCard = () => {
    return (
        <>
            <div className='container-fluid px-0 my-5'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <div className='bg-corpart'>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='copart-card'>
                            <div className='content'>
                                <h1 className='mb-3'>Sign Up For Free To Start Buying!</h1>
                                <p>Forget what you may have heard about the “stressful” process of buying cars from online - used car auctions.  We give you access to  the largest marketplace of used cars in the US including dealer-only inventory with the best customer support team ready to help make the process as simple as possible. Take advantage of our low fees and start buying today!</p>

                                <Link to="/Register" className='theme-btn mt-3'>Sign Up Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CorpartCard